import { connect } from "react-redux";
var ReactTooltip = require("react-tooltip");

var CurrentUser = require("lib/account/CurrentUser");
var HelpSectionLink = require("components/utility/HelpSectionLink");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var Glyphicon = require("components/utility/icons/Glyphicon");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");
var ReactTooltip = require("react-tooltip");

var WritingActions = require("lib/actions/WritingActions");

require("writing/evaluations/rubric_item_override.scss");

@connect(
  (state, props) => ({ }),
  (dispatch, props) => ({
    onUpdate: (evaluationID, updateData) => {
      dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: updateData })).then((e) => {
        dispatch(WritingActions.fetchEvaluations({
          filters: { subject_type: 'Answer', subject_id: e.subject_id },
          embeds: ["evaluation.autograder_data", "evaluation.score_details"]
        }))
      })
    }
  })
)

class RubricItemOverride extends React.Component {
  constructor(props) {
    super()
    autobind(this)

    this.state = { rubricOverride: {}, read_book: null }
  }

  saveEvaluation(e) {
    $wr.nope(e)

    var { evaluation } = this.props

    // Included both score (for immediate display) and adminScore (for the API Patch)
    var updateData = { rubric_override: { ...this.state.rubricOverride } }

    this.props.onUpdate(evaluation.id, updateData);

    window.wrNotifications.triggerDropDownNotification({
      title: "Rubric Edited",
      text: "You have edited the rubric for this answer",
      icon: "ok-sign"
    });

  }

  // quiz-level read the book dropdown
  isQuizReadBook() {
    return this.props.view == QUIZ_READ_BOOK
  }
  
  // extract polorizing hash from evaluation
  polarizingHash() {
    var { evaluation } = this.props
    if (!(evaluation && evaluation.autograder_data)) { return {} }

    if (evaluation.autograder_data.question_type == 'essay-question'){
      var rubricHash = evaluation.autograder_data.rubric
      return {...rubricHash['idea-quality'], ...rubricHash['organization'], ...rubricHash['writing-mechanics']}
    } else {
      return evaluation.autograder_data.polarizing

    }
  }

  // user is on a free account and hasn't manually graded answer
  hideAutograderScore(rubricKey) {
    var polarizingHash = this.polarizingHash()
    return !CurrentUser.isPremiumOrTrialAccount() && (!polarizingHash[rubricKey] || !polarizingHash[rubricKey]['admin_label'])
  }

  // user is on a free account and hasn't manually determined if the
  // student read the book on a quiz level
  hideQuizReadBook() {
    return !CurrentUser.isPremiumOrTrialAccount() && !this.props.evaluation.read_book
  }

  // warning should show for admins on free tier who haven't manually added grades
  // or when the rubric key is not present in polarizing hash
  showWarning(rubricKey) {
    var { leaves } = this.props;
    var { rubricOverride, read_book } = this.state

    var isEssay = this.props.evaluation && this.props.evaluation.autograder_data && this.props.evaluation.autograder_data.question_type == 'essay-question'
    if (rubricOverride[rubricKey] || read_book || isEssay) { return false }

    if (this.isQuizReadBook()) {
      return this.hideQuizReadBook()
    } else {
      return this.hideAutograderScore(rubricKey) || !_.has(leaves, rubricKey) || _.isEmpty(leaves[rubricKey]['value'])
    }
  }

  getDropdownText(rubricKey) {
    var { rubricOverride } = this.state

    var polarizingHash = this.polarizingHash()

    if (rubricOverride[rubricKey]) {
      return $wr.toTitleCase(rubricOverride[rubricKey])
    } else if (this.isQuizReadBook() && this.props.evaluation.read_book) {
      return $wr.toTitleCase(this.props.evaluation.read_book)
    } else if (!this.hideAutograderScore(rubricKey) && polarizingHash[rubricKey]) {
      var labelKey = polarizingHash[rubricKey]['admin_label'] ? 'admin_label' : 'label'
      return polarizingHash[rubricKey][labelKey] ? $wr.toTitleCase(polarizingHash[rubricKey][labelKey]) : 'None'
    } else {
      return 'None'
    }
  }

  // save new rubric grading
  handleRubricOverride(rubricKey, selectedOp) {
    var newRubricOverride = { ...this.state.rubricOverride }
    newRubricOverride[rubricKey] = selectedOp.toLowerCase()
    this.setState({ rubricOverride: newRubricOverride })

    if (this.props.onChange) {
      this.props.onChange(selectedOp.toLowerCase())
    }
  }

  // warning to tell user that rubric has not been auto-graded
  renderWarning(rubricKey) {
    if (this.showWarning(rubricKey)) {
      var tip = 'This item has not been graded'
      return <Glyphicon icon="exclamation-sign" className='warningIcon' dataTip={tip} />
    }
  }

  // allows teachers to edit rubric items
  renderDropdown(aggregateKey, rubricKey) {
    var { leaves } = this.props
    if (leaves[rubricKey] && leaves[rubricKey].label_options) { 
      var options = leaves[rubricKey].label_options
    } else {
      var options = AutograderDisplayConfig.getLeafOptions(aggregateKey)
    }
    
    // options for rubric item
    var dropdownOps = _.map(options, (option) => {
      return (
        <ButtonDropdownOption key={option}
          onClick={() => this.handleRubricOverride(rubricKey, option)}>
          {$wr.toTitleCase(option)}
        </ButtonDropdownOption>
      );
    })

    return (
      <ButtonDropdown text={this.getDropdownText(rubricKey)}
        dropdownDisplay="link" className="rubricLabelSelector">
        {dropdownOps}
      </ButtonDropdown>
    )
  }

  // renders multiple rubric items as table
  renderTableView() {
    var { leaves } = this.props
    if (leaves) {
      var rows = _.keys(leaves).map((rubricKey) => {
        var leafData = leaves[rubricKey]
        var aggregateKey = AutograderDisplayConfig.getLeafAggregateKey(rubricKey)
        var title = leafData.display_name || AutograderDisplayConfig.getLeafName(aggregateKey);
        var dataTip = leafData.tooltip || AutograderDisplayConfig.getLeafDescription(aggregateKey);

        LuckyOrangeClient.tagComponent(`ScoringDataOverride: ${aggregateKey}`);

        return (
          <tr key={aggregateKey}>
            <td className="titleCell" data-tip={dataTip}>
              {title}
            </td>
            <td>
              {this.renderDropdown(aggregateKey, rubricKey)}
            </td>
            <td>
              {this.renderWarning(rubricKey)}
            </td>
          </tr>
        );
      });

      return (
        <table className="table table-borderless">
          <tbody>
            {rows}
          </tbody>
        </table>
      )
    }
  }

  // renders read the book option and dropdown on quiz level
  renderQuizReadBook() {
    LuckyOrangeClient.tagComponent(`ScoringDataOverride: Quiz-Level ${READ_BOOK_AGG_KEY}`);
    var title = AutograderDisplayConfig.getLeafName(READ_BOOK_AGG_KEY);
    var dataTip = "Whether the entirety of the student's work provides enough text evidence to prove that the student read the book."

    return (
      <div key={`Quiz-${READ_BOOK_AGG_KEY}`} className='rubricOverrideInlineContainer'>
        <div className="titleContainer" data-tip={dataTip}>
          {title}
          <ReactTooltip effect="solid" className='readBookDataTip' />
        </div>
        <div className="dropdownContainer">
          {this.renderDropdown(READ_BOOK_AGG_KEY, READ_BOOK_RUBRIC_KEY)}
        </div>
        <div className="warningContainer">
          {this.renderWarning(READ_BOOK_RUBRIC_KEY)}
        </div>
      </div>
    );
  }

  renderCategories() {
    if (this.isQuizReadBook()) {
      return this.renderQuizReadBook()
    } else {
      return this.renderTableView()
    }
  }

  renderSaveButton() {
    if (!_.isEmpty(this.state.rubricOverride) && this.props.view != QUIZ_READ_BOOK) {
      return (
        <div className="btnContainer">
          <button onClick={this.saveEvaluation} className="btn btn-primary saveBtn">Save</button>	
        </div>
      )
    }
  }

  render() {
    var { leaves, view } = this.props
    
    if (!leaves || _.size(leaves) == 0) {
      return (
        <div className="rubricItemOverride">
          <p className="showToggle">No scoring details available.</p>
        </div>
      );
    }
    
    var containerClass = view ? `rubricItemOverride ${view}` : `rubricItemOverride ${TABLE_VIEW}`

    return (
      <div className={containerClass}>
        <div className="scoringCategories">
          {this.renderCategories()}
        </div>
        { this.renderSaveButton() }
      </div>
    );
  }
}

var QUIZ_READ_BOOK = 'quizReadBook'
var TABLE_VIEW = 'tableView'
var READ_BOOK_AGG_KEY = 'aggregate-read-book'
var READ_BOOK_RUBRIC_KEY = 'crit-evi-cote-bert-read-book-1'


RubricItemOverride.propTypes = StrictPropTypes({
  onUpdate: PropTypes.func,
  leaves: PropTypes.object, // Polarizing after aggregating and filtering
  evaluation: PropTypes.object,
  view: PropTypes.string,
  onChange: PropTypes.func,
  // onChange: PropTypes.func.isRequired,
});

module.exports = RubricItemOverride;


// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/RubricItemOverride.js